import { useQuery } from "@tanstack/react-query";
import { getDashboardAccessRequests } from "../../../api/dashboardAccessRequestsApi";
import { DashboardAccessRequest } from "../../../pages/Admin/Requests/dashboardAccessRequestsMockData";

export const DASHBOARD_ACCESS_REQUESTS_QUERY_KEY = ["dashboard-access-requests"];

export const useDashboardAccessRequests = () => {
  const { data, isLoading } = useQuery<DashboardAccessRequest[]>(DASHBOARD_ACCESS_REQUESTS_QUERY_KEY, () =>
    getDashboardAccessRequests("pending")
  );
  return { requests: data ?? [], isLoading };
};
